const steps = [
  {
    number: '01',
    title: 'Appel d\'Urgence',
    description: 'Contactez-nous par email ou via notre formulaire 24h/24. Notre équipe évalue votre situation et planifie l\'intervention.',
    icon: 'ri-phone-line'
  },
  {
    number: '02',
    title: 'Intervention Rapide',
    description: 'Un technicien qualifié se déplace rapidement avec l\'équipement nécessaire pour diagnostiquer et résoudre le problème.',
    icon: 'ri-car-line'
  },
  {
    number: '03',
    title: 'Diagnostic Précis',
    description: 'Analyse complète de la panne avec des outils professionnels. Explication claire du problème et des solutions possibles.',
    icon: 'ri-search-line'
  },
  {
    number: '04',
    title: 'Réparation Efficace',
    description: 'Réparation immédiate avec des pièces de qualité. Respect des normes suisses et garantie sur l\'intervention.',
    icon: 'ri-tools-line'
  },
  {
    number: '05',
    title: 'Test et Vérification',
    description: 'Vérification complète du bon fonctionnement. Tests de sécurité et optimisation des performances.',
    icon: 'ri-checkbox-circle-line'
  },
  {
    number: '06',
    title: 'Suivi et Garantie',
    description: 'Rapport d\'intervention détaillé. Conseils d\'entretien et garantie sur les réparations effectuées.',
    icon: 'ri-file-list-line'
  }
];

export default function MaintenanceProcess() {
  return (
    <section className="py-24 bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-orange-400">Notre Processus</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Intervention Professionnelle en 6 Étapes
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-400 max-w-3xl mx-auto">
            Un processus éprouvé pour garantir une intervention rapide, efficace et conforme aux normes suisses. De l'appel d'urgence au suivi post-intervention.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-gray-800 rounded-2xl p-8 border border-gray-700 hover:border-orange-500/40 transition-all duration-300 h-full">
                <div className="flex items-start gap-4 mb-4">
                  <div className="text-5xl font-bold text-orange-500/20">{step.number}</div>
                  <div className="w-12 h-12 flex items-center justify-center bg-orange-500/20 rounded-lg flex-shrink-0 mt-1">
                    <i className={`${step.icon} text-2xl text-orange-400`}></i>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{step.title}</h3>
                <p className="text-gray-400 leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-orange-500/20"></div>
              )}
            </div>
          ))}
        </div>
        <div className="mt-16 bg-gradient-to-r from-orange-600 to-orange-500 rounded-2xl p-8 md:p-12 text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <i className="ri-time-line text-4xl text-white"></i>
            <h3 className="text-3xl font-bold text-white">Temps de Réponse Garanti</h3>
          </div>
          <p className="text-xl text-white/90 mb-6 max-w-2xl mx-auto">
            Intervention d'urgence en moins de 2 heures dans le canton de Genève. Service prioritaire pour nos clients sous contrat de maintenance.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:info@casarenovaplus.ch"
              className="inline-flex items-center justify-center gap-2 bg-white text-orange-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line text-xl"></i>
              Nous Contacter
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 bg-orange-800 text-white px-8 py-4 rounded-lg font-semibold hover:bg-orange-900 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line text-xl"></i>
              Demander un Devis
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
